var render, staticRenderFns
import script from "./toSignUp.vue?vue&type=script&lang=js"
export * from "./toSignUp.vue?vue&type=script&lang=js"
import style0 from "./toSignUp.vue?vue&type=style&index=0&id=11ed20e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ed20e4",
  null
  
)

export default component.exports